
import { RouteShareService } from "src/app/shared/services/route-share.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_BLOCK_PREFIX, BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_DOCSEARCH(name: string = "unnamed", BH: BlocklyHelperService, rss: RouteShareService,): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.CAT_DATEN_INHALTE, name: name, contents: [] };
  const generalBlockStle = { colour: BLOCKLY_COLORS.CAT_DATEN_INHALTE }

  const documentOptions = rss._allDokuments();
  const imageOptions = rss._allImageSkills();

  cat.contents = [
    BH.label("Dokumentensuche"),
    BH.StackedBlockContents("DOCUMENT", documentOptions.length > 0 ? documentOptions : ["???"], "Referenz (📄 Dokument)"),
    BH._custom("BLOCK_STACK_IMAGE", "@output:IMAGE\nReferenz (🖼️ Bild):{{value:dropdown=" + (imageOptions.length > 0 ? imageOptions : ["???"]).join(",") + "}}", "'{{value}}'", generalBlockStle),
    BH._custom("BLOCK_STACK_DOCUMENT_CONTENT", "@output:String\nTextinhalt von Dokument:{{value:dropdown=" + (documentOptions.length > 0 ? documentOptions : ["???"]).join(",") + "}}", "(await RAGAI.DOWNLOAD.getMDContent('{{value}}')).content", generalBlockStle),

    BH.label("Funktionen"),
    BH.withNested(
      { kind: 'block', type: 'DOC_SEARCH_NEW_V2' },
      [
        { forValue: 'SEARCHSTRING', isShadow: false, targetBlockType: 'DUMMY_STRING', targetBlockDefaults: { text: 'Suchbegriff' } },
        { forValue: 'DOC0', isShadow: false, targetBlockType: 'BLOCK_STACK_DOCUMENT' }
      ]
    ),

    //    BH.label("Zugriff auf Dokumente")

  ];

  // Deprecated – nur registrieren für bestehende Workspaces, nicht in Toolbox anzeigen
  BH.withNested(
    BH._custom(
      "DOC_SEARCH",
      BLOCKLY_CARD_PREFIX.AI_HELPERS +
      `- [CARD]\nDoc-Search-API verwenden
Suchstring: {{searchstring}}
Anzahl Ergebnisse: {{searchcount:number=5}}
Prozentuale Übereinstimmung (0-1): {{minscore:number=0}}`,
      `await RAGAI.DOCSEARCH.searchAsCard({{searchstring}}, {{searchcount}}, {{minscore}});`,
      { inputsInline: true, colour: BLOCKLY_COLORS.CARDS }
    ),
    [
      { forValue: "searchstring", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
    ]
  );
  BH._custom("aa", "{{a[@check=DOC_SEARCH_JSON]}}", "c");
  BH.withNested(
    BH._custom(
      "DOC_SEARCH_NEW_SEARC_IN_DOCS",
      `@output:DOC_SEARCH_JSON\n[🔎 Doc Searcher]\n {{resulttype:dropdown=⎇ Suchanfrage liefert Ergebnisse|hasresults,Ergebnisse als Tabelle|table, Ergebnisse als Text|text,🔢 Anzahl der Ergebnisse|counter,⌗ Suchantwort als JSON-Objekt|json}}
        - Anfrage:
    {{searchstring}}
    Dokumenten Liste:
    {{doclist}}
    Anzahl Suchtreffer: {{searchcount:number=5}}
    Ignoriere Ergebnisse mit weniger als: {{minscore:number=79}}% Übereinstimmung`,
      `await RAGAI.DOCSEARCH.searchAsJson({{searchstring}}, {{doclist}},{{searchcount}}, {{minscore}}, '{{resulttype}}')`,
      { inputsInline: true, colour: BLOCKLY_COLORS.MESSAGES_LIGHT }
    ),
    [
      { forValue: "searchstring", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
      { forValue: "doclist", isShadow: true, targetBlockType: 'DOC_LIST_JOINING' }
    ]
  );
  BH.withNested(
    BH._custom(
      "DOC_SEARCH_NEW_SEARC_IN_DOCS_HAS_RESULTS",
      BLOCKLY_BLOCK_PREFIX.IF + `checke ob {{searchBlock}} dann tu {{actions:statement[@check=ACTION]}} sonst tu {{actions2:statement[@check=ACTION]}}
        `,
      `if({{searchBlock}})) {
        {{hasResults}}

        }else{
           {{noResults}}

          }`,
      { inputsInline: true, colour: BLOCKLY_COLORS.IF }
    ),
    [
      { forValue: "searchBlock", isShadow: false, targetBlockType: 'DOC_SEARCH_NEW_SEARC_IN_DOCS', targetBlockDefaults: { 'resulttype': 'hasresults' } }
    ]
  );
  BH.withNested(
    BH._custom("DOC_LIST_JOINING", "@output:String\nDokumenten Liste\n📄: {{parts:statement[@check=DOCCHAINITEM]}}", "[{{parts}}]", { colour: BLOCKLY_COLORS.CHAINS, nextStatement: 'DOCCHAINITEM', connection: 'none' })
    , [{
      forValue: "parts",
      isShadow: true,
      targetBlockType: 'DOC_LIST_JOINING_DOC'
    }]
  );
  BH.withNested(
    BH._custom("DOC_LIST_JOINING_DOC", "📄:{{doc}}", "{{doc}},", {}),
    [{
      forValue: "doc",
      isShadow: true,
      targetBlockType: BLOCKLY_DUMMY.STRING,
    }]
  );

  return cat;




}



/*
DAS IST DER SUPER GEHEIME QUELLCODE UM EINJE JOIN LISTE IN BLOCKY ZU MACHEN!!!!
const listJoinBlock = {
  "type": "doc_list_join",
  "message0": "Dokumenten Liste %1",
  "args0": [
    {
      "type": "input_dummy",
      "name": "EMPTY"
    }
  ],
  "output": "Array",
  "colour": 260,
  "helpUrl": "",
  "tooltip": "Verbindet mehrere Listen oder Elemente zu einer Liste.",
  "mutator": "list_join_mutator"
};

//@ts-ignore
window.BL123 = Blockly;
Blockly.defineBlocksWithJsonArray([listJoinBlock]);



const ListJoinMutatorMixin = {
  itemCount_: 0,

  saveExtraState: function () {
    return { itemCount: this.itemCount_ };
  },
  //@ts-ignore
  loadExtraState: function (state) {
    this.itemCount_ = state.itemCount || 0;
    this.updateShape_();
  },
  //@ts-ignore
  decompose: function (workspace) {
    const containerBlock = workspace.newBlock('list_join_container');
    containerBlock.initSvg();
    let connection = containerBlock.getInput('STACK').connection;
    for (let i = 0; i < this.itemCount_; i++) {
      const itemBlock = workspace.newBlock('list_join_item');
      itemBlock.initSvg();
      connection.connect(itemBlock.previousConnection);
      connection = itemBlock.nextConnection;
    }
    return containerBlock;
  },
  //@ts-ignore
  compose: function (containerBlock) {
    let itemBlock = containerBlock.getInputTargetBlock('STACK');
    const connections = [];
    while (itemBlock) {
      connections.push(itemBlock.valueConnection_);
      itemBlock = itemBlock.nextConnection &&
        itemBlock.nextConnection.targetBlock();
    }
    this.itemCount_ = connections.length;
    this.updateShape_();
    for (let i = 0; i < this.itemCount_; i++) {
      if (connections[i]) {
        //@ts-ignore
        this.getInput('ADD' + i).connection.connect(connections[i]);
      }
    }
  },
  //@ts-ignore
  saveConnections: function (containerBlock) {
    let itemBlock = containerBlock.getInputTargetBlock('STACK');
    let i = 0;
    while (itemBlock) {
      //@ts-ignore
      const input = this.getInput('ADD' + i);
      itemBlock.valueConnection_ = input && input.connection.targetConnection;
      i++;
      itemBlock = itemBlock.nextConnection &&
        itemBlock.nextConnection.targetBlock();
    }
  },

  updateShape_: function () {
    // Erst alle alten ADD-Inputs weg
    let i = 0;
    //@ts-ignore
    while (this.getInput('ADD' + i)) {
      //@ts-ignore
      this.removeInput('ADD' + i);
      i++;
    }
    // Dann neue Inputs hinzufügen
    for (let i = 0; i < this.itemCount_; i++) {
      //@ts-ignore
      const input = this.appendValueInput('ADD' + i).setAlign(Blockly.ALIGN_RIGHT);
      if (i === 0) {
        input.appendField('Element');
      }
    }
  }
};



Blockly.defineBlocksWithJsonArray([
  {
    "type": "list_join_container",
    "message0": "Elemente %1 %2",
    "args0": [
      { "type": "input_dummy" },
      { "type": "input_statement", "name": "STACK" }
    ],
    "colour": 260,
    "tooltip": "",
    "enableContextMenu": false
  },
  {
    "type": "list_join_item",
    "message0": "Element",
    "previousStatement": null,
    "nextStatement": null,
    "colour": 260,
    "tooltip": "",
    "enableContextMenu": false
  }
]);




//@ts-ignore
Blockly.Extensions.registerMutator('list_join_mutator', ListJoinMutatorMixin, null, ['list_join_item']);

 */

